import { DEFAULT_MULTIPLIER, IMAGE_ASSETS } from '../Enums/ImageAssets';
import './Components.scss';
import packageJson from '../../package.json';

function GameVersion() {

    return (

        <div className="game-version">
            <span>{packageJson.version || ''}</span>
        </div>
    );
}

export default GameVersion;
